import { ref } from "vue";
import { authCookies } from "@/services/cookies";

class repo {
  yearBreadCrumb = JSON.parse(localStorage.getItem("TASIS:BREADCRUMB")) || [];
  gradeBreadCrumb = [];
  user = authCookies.getUser() || {};
  sideBarTeacherItems = [
    {
      title: "grades",
      icon: "people-roof",
      to: "/teacher/grades",
    },
    {
      title: "study_plan",
      icon: "calendar-check",
      to: "/teacher/study-plan",
    },
    {
      title: "holidays",
      icon: "calendar-days",
      to: "/teacher/holidays",
    },
  ];
  sideBarItems = [
    {
      title: "administrative",
      icon: "toolbox",
      to: "/administrative",
      permission: true,
      opened: true,

      children: [
        {
          title: "years",
          icon: "calendar-days",
          to: "/years",
          permission: "dashboard.year.list",
        },

        {
          title: "teachers",
          icon: "user-tie",
          to: "/teachers",
          permission: "dashboard.teacher.list",
        },
        {
          title: "students",
          icon: "user-graduate",
          to: "/students",
          permission: "dashboard.student.list",
        },
        {
          title: "employees",
          icon: "user-group",
          to: "/employees",
          permission: "dashboard.employee.list",
        },
        {
          title: "roles",
          icon: "user-shield",
          to: "/roles",
          permission: "dashboard.role.list",
        },

        {
          title: "departments",
          icon: "school",
          to: "/departments",
          permission: "dashboard.department.list",
        },
        {
          title: "buses",
          icon: "bus",
          to: "/buses",
          permission: "dashboard.bus.list",
        },
        {
          title: "sliders",
          icon: "sliders",
          to: "/sliders",
          permission: "dashboard.slider.list",
        },
        {
          title: "billboards",
          icon: "bullhorn",
          to: "/billboards",
          permission: "dashboard.billboard.list",
        },
        {
          title: "frequency_notes",
          icon: "note-sticky",
          to: "/frequency-notes",
          permission: "dashboard.frequencyNote.list",
        },
        {
          title: "settings",
          icon: "gear",
          to: "/settings",
          permission: "dashboard.setting.list",
        },
        {
          title: "notifications",
          icon: "bell",
          to: "/notifications",
          permission: "dashboard.notification.list",
          unreadBadge: true,
        },
        // {
        //   title: "questions_bank",
        //   icon: "bank",
        //   to: "/questions",
        //   permission: "dashboard.question.list",
        // },
      ],
    },
    {
      title: "complaints_box",
      icon: "inbox",
      to: "/complaints",
      permission: true,
      opened: false,
      children: [
        {
          title: "complaints_inbox",
          icon: "inbox",
          to: "/complaints/inbox",
          permission: "dashboard.complaint.list",
        },
        {
          title: "complaint_categories",
          icon: "tags",
          to: "/complaints/categories",
          permission: "dashboard.complaintCategory.list",
        },
      ],
    },
    {
      title: "educational",
      icon: "book-open-reader",
      to: "/educational",
      permission: true,
      opened: true,

      children: [
        {
          title: "grades",
          icon: "people-roof",
          to: "/grades",
          permission: "dashboard.grade.list",
        },
        {
          title: "categories",
          icon: "list-ul",
          to: "/categories",
          permission: "dashboard.category.list",
        },
      ],
    },
    {
      title: "competitions",
      icon: "trophy",
      to: "/competitions",
      permission: true,
      opened: false,
      children: [
        {
          title: "competitions",
          icon: "trophy",
          to: "/competitions",
          permission: "dashboard.competition.list",
        },
        {
          title: "competition_repo_questions",
          icon: "database",
          to: "/competition-repo-questions",
          permission: "dashboard.competitionRepoQuestion.list",
        },
        {
          title: "competition_awards",
          icon: "ranking-star",
          to: "/competitions/totals",
          permission: "dashboard.competition.list",
        },
        {
          title: "all_competition_winners",
          icon: "medal",
          to: "/competitions/all-winners",
          permission: "dashboard.competition.allWinners",
        },
      ],
    },
  ];

  nationalities = [
    "أفغاني",
    "ألباني",
    "جزائري",
    "أمريكي",
    "أندوري",
    "أنغولي",
    "أنتيغواني",
    "أرجنتيني",
    "أرميني",
    "أسترالي",
    "نمساوي",
    "أذربيجاني",
    "باهامي",
    "بحريني",
    "بنغالي",
    "باربادوسي",
    "باربودي",
    "باتسوانا",
    "بيلاروسي",
    "بلجيكي",
    "بليزي",
    "بينييني",
    "بوتاني",
    "بوليفي",
    "بوسني",
    "برازيلي",
    "بريطاني",
    "بروني",
    "بلغاري",
    "بوركيني",
    "بورمي",
    "بوروندي",
    "كمبودي",
    "كاميروني",
    "كندي",
    "كاب فيردي",
    "أفريقي وسط",
    "تشادي",
    "تشيلي",
    "صيني",
    "كولومبي",
    "قُمُرِي",
    "كونغولي",
    "كوستاريكي",
    "كرواتي",
    "كوبي",
    "قبرصي",
    "تشكي",
    "دنماركي",
    "جيبوتي",
    "دومينيكاني",
    "هولندي",
    "تيموري شرقي",
    "إكوادوري",
    "مصري",
    "إماراتي",
    "غيني استوائي",
    "إريتري",
    "استوني",
    "إثيوبي",
    "فيجي",
    "فلبيني",
    "فنلندي",
    "فرنسي",
    "غابوني",
    "غامبي",
    "جورجي",
    "ألماني",
    "غاني",
    "يوناني",
    "غرينادي",
    "غواتيمالي",
    "غيني-بساوي",
    "غيني",
    "غياني",
    "هايتي",
    "هرزغوفيني",
    "هندوراسي",
    "هنغاري",
    "كيريباسي",
    "آيسلندي",
    "هندي",
    "إندونيسي",
    "إيراني",
    "عراقي",
    "أيرلندي",
    "فلسطيني",
    "إيطالي",
    "إيفواري",
    "جامايكي",
    "ياباني",
    "أردني",
    "كازاخستاني",
    "كينايي",
    "كيتين ونيفيسي",
    "كويتي",
    "قيرغيزي",
    "لاوسي",
    "لاتفي",
    "لبناني",
    "ليبيري",
    "ليبي",
    "ليختنشتايني",
    "لتواني",
    "لوكسمبورغي",
    "مقدوني",
    "ملاجيشي",
    "ملاوي",
    "ماليزي",
    "مالديفي",
    "مالي",
    "مالطي",
    "جزر مارشالية",
    "موريتاني",
    "موريشيوسي",
    "مكسيكي",
    "ميكرونيزي",
    "مولدوفي",
    "موناكو",
    "منغولي",
    "مغربي",
    "موسوتو",
    "موتسوانا",
    "موزمبيقي",
    "ناميبي",
    "ناوروي",
    "نيبالي",
    "نيوزيلندي",
    "نيكاراغوي",
    "نيجيري",
    "نيجيري",
    "كوري شمالي",
    "أيرلندي شمالي",
    "نرويجي",
    "عماني",
    "باكستاني",
    "بالاواني",
    "بنمي",
    "بابوا غينيا الجديدة",
    "باراغواي",
    "بيروفي",
    "بولندي",
    "برتغالي",
    "قطري",
    "روماني",
    "روسي",
    "رواندي",
    "سانت لوشا",
    "سلفادوري",
    "ساموي",
    "سان ماريني",
    "ساو توميان",
    "سعودي",
    "اسكتلندي",
    "سنغالي",
    "صربي",
    "سيشلي",
    "سيراليوني",
    "سنغافوري",
    "سلوفاكي",
    "سلوفيني",
    "جزر سليمان",
    "صومالي",
    "جنوب أفريقي",
    "كوري جنوبي",
    "إسباني",
    "سريلانكي",
    "سوداني",
    "سورينامي",
    "سوازيلاندي",
    "سويدي",
    "سويسري",
    "سوري",
    "تايواني",
    "طاجيكي",
    "تنزاني",
    "تايلندي",
    "توجولي",
    "تونغي",
    "ترينيدادي/توباغوني",
    "تونسي",
    "تركي",
    "توفالي",
    "أوغندي",
    "أوكراني",
    "أوروغوياني",
    "أوزبكستاني",
    "فنزويلي",
    "فيتنامي",
    "ويلزي",
    "يمني",
    "زامبي",
    "زيمبابوي",
  ];
}
export const Repo = ref(new repo()).value;
